import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import ProfileState from '../../../../stores/ProfileStore';
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const onFieldChange = (field) => {
    const data = {};
    let permissionText;
    data[field.name] = field.value;
    if (field.name === 'email') {
        permissionText = field.extra;
    }
    return ProfileState.updateUserPermissions(data, permissionText);
};
const fields = [
    {
        name: 'email',
        value: false,
        type: 'checkbox',
        rules: 'boolean',
        hooks: {
            onChange: onFieldChange
        }
    },
    {
        name: 'research',
        type: 'checkbox',
        value: false,
        rules: 'boolean',
        hooks: {
            onChange: onFieldChange
        }
    }
];
export default new MobxReactForm({ fields }, { plugins });
